import { Injectable } from '@angular/core';
import { NetworkingService } from '../networking.service';
import { LessonPageItemType } from '../../data/models/LessonPageItemType';
import { map, Observable } from 'rxjs';
import { API } from '../../data/api'

@Injectable({
  providedIn: 'root'
})
export class LessonPageItemTypeService {

  constructor(private networkingService: NetworkingService) { }

  getLessonPageItemTypeList(): Observable<LessonPageItemType[]> {
    return this.networkingService.getRequest(API.lessonPageItemTypeList)
      .pipe(
        map(response => response as LessonPageItemType[])
      );
  }

  getLessonPageItemTypeDetails(id: string): Observable<LessonPageItemType> {
    const endpoint = API.lessonPageItemTypeDetails(id);
    return this.networkingService.getRequest(endpoint)
      .pipe(
        map(response => response as LessonPageItemType)
      );
  }
}
